// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picImgWrap{width:100%;height:100%;border-radius:100%;overflow:hidden;display:flex;background-color:#fff}@media screen and (max-width:300px){.mainUserName{font-size:15px!important}.mainIcon{width:.7rem!important}.mainRefreshBtn{width:20px!important}}", ""]);
// Exports
module.exports = exports;
